export enum ProductTypeEnum {
    fewLife = 'card_life__type_1',
    mediumLife = 'card_life__type_2',
    manyLife = 'card_life__type_3',
    shortUnlimLife = 'card_unlim_life__type_1',
    mediumUnlimLife = 'card_unlim_life__type_2',
    longUnlimLife = 'card_unlim_life__type_3',
    requestLife = 'card_life__get_from_friend',
}

export enum ProductStickerEnum {
    none = 'without_sticker',
    benefit = 'benefit',
    playersChoice = 'player_choose',
}

export enum ProductModifiersEnum {
    coins = 'coins',
    lives = 'lives',
    unlimLives = 'unlimLives', //в ms
}

export type ProductModifiers = {
    [key in ProductModifiersEnum]?: number
}

export interface ProductModel {
    id: string,
    type: ProductTypeEnum,
    modifiers: ProductModifiers
    sticker?: ProductStickerEnum,
    stickerInfo?: string,
}

// User's data

export interface IUserData {
    id: string;
    name: string;
    balance: IUserBalance;
    friends: IFriendData[];
    albums: string[];
    progress: IPictureProgress[];
}

export interface IUserBalance {
    livesCount: number;
    livesTimestamp: number;
    unlimLivesPeriod: number;
    unlimLivesTimestamp: number;
    coins: number;
    needleBoosterCount: number;
    brushBoosterCount: number;
    hookBoosterCount: number;
}

export interface IFriendData {
    id: string;
    photoSrc: string;
    name: string;
    embroideriesCount: number;
    canGivesLife: boolean;
}

export interface IPictureProgress {
    id: string;
    progress: number;
    savedPictureSrc: Uint8ClampedArray;
    time: number;
}

// Albums and pictures

export interface IPictureData {
    id: string;
    src: string;
    title: string;
    name: string;
    description: string;
    size: number;
}

export interface IAlbumData {
    id: string;
    title: string;
    categories: string[];
    coverSrc: string;
    pictures: string[];
}

export interface IAlbumsLibraryData {
    id: string;
    albums: IAlbumData[];
    pictures: IPictureData[];
    categories: string[];
}



